<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{ this.$t('Visa-Price') }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <v-btn
                v-if="this.$route.query.isl == 'yeni'"
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click="addVizeFiyat()"
                flat
              >
                <span class="hidden-sm-and-down"> {{ $t('save_button') }} </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">Yeni</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Update"
                slot="activator"
                v-if="this.$route.query.isl == 'get'"
                @click="updateVizeFiyat()"
                flat
              >
                <span class="hidden-sm-and-down"> {{ $t('Update') }} </span>
                <v-icon right dark>system_update_alt</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12>
          <v-tabs
            style="width: 100%; height: 100%"
            dark=""
            v-model="active"
            color="info"
            slot="extension"
            slider-
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#0">
              {{ $t("tab_general") }}
            </v-tab>
            <v-tab href="#1"> {{ $t('Price-Details-v3') }} </v-tab>

            <v-tab-item :id="'0'">
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex pb-3 xs12 sm12 md6>
                    <v-card light style="min-height: 600px">
                      <v-card-title primary title>
                        <v-flex xs12 sm12 pt-2 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span
                                  class="headline black--text font-weight-bold"
                                >
                                  Vize Bilgileri
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md6>
                            <konsoloslukminiara
                              v-model="fiyatParams.VizeFiyat.SaticiKodu"
                            >
                            </konsoloslukminiara>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-autocomplete
                              v-model="fiyatParams.VizeFiyat.Tip1"
                              :items="vizeTipiItems"
                              item-text="text"
                              item-value="value"
                              hide-details=""
                              :label="$t('Visa-Type')"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <tarihim
                              v-model="fiyatParams.VizeFiyat.Donem1"
                              :etiket="$t('Term-Start')"
                              v-bind:defaultvalue="'ok'"
                              :detaygizle="true"
                            ></tarihim>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <tarihim
                              v-model="fiyatParams.VizeFiyat.Donem2"
                              :etiket="$t('Term-End')"
                              v-bind:defaultvalue="'ok'"
                              :detaygizle="true"
                            ></tarihim>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-autocomplete
                              v-model="fiyatParams.VizeFiyat.GirisTipi"
                              :items="vizeGirisItems"
                              item-text="text"
                              item-value="value"
                              :hide-details="true"
                              label="Giriş Tipi"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                               <vizecesidi 
                               :label="$t('Visa-Type-v2')" 
                               :getcode="fiyatParams.VizeFiyat.SaticiKodu" 
                               :getkk="fiyatParams.VizeFiyat.Tip1" 
                               v-model="fiyatParams.VizeFiyat.VizeCesit">
                             </vizecesidi>
                          </v-flex>
                          <v-flex xs12 sm6 md12>
                            <geneltipara
                              tip="VizeFiyatTipi"
                              ::label="$t('Price-Type-v2')"
                              v-model="fiyatParams.VizeFiyat.FiyatTipi"
                            ></geneltipara>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <parainput
                              :simge="getparabirimi()"
                              :etiket="'Alış Fiyat'"
                              :autocomplete="'autocomplete'"
                              v-model="fiyatParams.VizeFiyat.AlisFiyat"
                            >
                            </parainput>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <parainput
                              :simge="getparabirimi()"
                              :etiket="'Satış Fiyat'"
                              :autocomplete="'autocomplete'"
                              v-model="fiyatParams.VizeFiyat.SatisFiyat"
                            >
                            </parainput>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-autocomplete
                              hide-details=""
                              :items="doviztipi"
                              clearable
                              item-text="Title"
                              item-value="DovizKod"
                              :label="$t('Currency-Type')"
                              v-model="fiyatParams.VizeFiyat.SatisPara"
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm12 md6>
                            <parainput
                              :simge="getparabirimi()"
                              :etiket="$t('VAT') + ' %'"
                              :autocomplete="'autocomplete'"
                              v-model="fiyatParams.VizeFiyat.KDV"
                            >
                            </parainput>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-textarea
                              :label="$t('Description')"
                              v-model="fiyatParams.VizeFiyat.Aciklama"
                            >
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex pb-3 xs12 sm12 md6>
                    <v-card light style="min-height: 600px">
                      <v-card-title primary title>
                        <v-flex xs12 sm12 pt-2 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span
                                  class="headline black--text font-weight-bold"
                                >
                                  {{ $t('Current-Details') }}
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                      <v-card-text>
                        <v-layout column style="height: 518px">
                          <v-flex xs12 sm12 md12 style="overflow: auto">
                            <v-toolbar flat color="white">
                              <v-layout row wrap>

                              
                              <v-flex xs12 sm12 md10>
                                <cariaracomp v-model="cariValue"></cariaracomp>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 sm12 md2>
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-0"
                                  @click="addCari()"
                                  > {{ $t('Add-v2', { value: $t('Currentcode_label')}) }} 
                                  </v-btn>
                              </v-flex>
                            </v-layout>
                            </v-toolbar>
                            <v-data-table
                              :headers="headersCari"
                              :items="fiyatParams.CariList"
                              class="elevation-1 mt-5"
                              item-key="kod"
                            >
                              <template v-slot:no-data>
                                <v-alert
                                  :value="true"
                                  color="error"
                                  icon="warning"
                                >
                                  this.$t('No-Records-Found')
                                </v-alert>
                              </template>
                              <template v-slot:items="props">
                                <td>{{ props.item.kod }}</td>
                                <td
                                  v-if="!sayfayetki.Delete"
                                  class="justify-end layout pl-4"
                                >
                                  <v-icon small @click="deleteCari(props.item)">
                                    delete
                                  </v-icon>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>

            <v-tab-item :id="'1'">
              <v-container fluid grid-list-md>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="sigorta"
                          :tip="1"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="hizmet"
                          :tip="2"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="diger"
                          :tip="3"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="ekhizmet1"
                          :tip="4"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="ekhizmet2"
                          :tip="5"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="ekhizmet3"
                          :tip="6"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="ekhizmet4"
                          :tip="7"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="ekhizmet5"
                          :tip="8"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="ekhizmet6"
                          :tip="9"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ekhizmetler
                          v-model="ekhizmet7"
                          :tip="10"
                          :doviztipi="doviztipi"
                        ></ekhizmetler>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tool from "@/components/app/coper/tools";
import konsoloslukminiara from "@/components/app/coper/comp/konsoloslukminiara.vue";
import tarihim from "@/components/app/customcomp/tarihim";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import parainput from "@/components/app/customcomp/parainput.vue";
import auth from "@/api/auth.js";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import ekhizmetler from "@/components/app/coper/tanitimlar/vizefiyat/comp/ekhizmetler";
import vizecesidi from "@/components/app/coper/component/vizecesidi.vue";

export default {
  data() {
    return {
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      active: 0,
      doviztipi: [],
      cariValue: null,
      sigorta: Object.assign({}, this.ekHizmetParams),
      hizmet: Object.assign({}, this.ekHizmetParams),
      diger: Object.assign({}, this.ekHizmetParams),
      ekhizmet1: Object.assign({}, this.ekHizmetParams),
      ekhizmet2: Object.assign({}, this.ekHizmetParams),
      ekhizmet3: Object.assign({}, this.ekHizmetParams),
      ekhizmet4: Object.assign({}, this.ekHizmetParams),
      ekhizmet5: Object.assign({}, this.ekHizmetParams),
      ekhizmet6: Object.assign({}, this.ekHizmetParams),
      ekhizmet7: Object.assign({}, this.ekHizmetParams),
      ekHizmetParams: {
        HizmetTip: 0,
        Satici: {
          id: "0",
          kod: null,
          isim: "",
          tip: 0,
          intField: null,
        },
        Alis: 0.0,
        Satis: 0.0,
        AlisKur: 0.0,
        SatisKur: 0.0,
        AlisPara: "TL",
        SatisPara: "TL",
        SatisKDV: 0,
      },
      VizeCesidiSatici: {
        id: "0",
        kod: null,
        isim: "",
        tip: 0,
        intField: null,
      },
      fiyatParams: {
        VizeFiyat: {
          Ref: 0,
          SaticiKodu: null,
          Donem1: null,
          Donem2: null,
          Tip1: 0,
          VizeCesit: {
            id: "0",
            kod: null,
            isim: null,
            tip: 0,
            intField: null,
          },
          GirisTipi: 0,
          FiyatTipi: {
            id: 0,
            kod: null,
            isim: null,
            tip: 0,
            intField: null,
          },
          AlisFiyat: 0.0,
          AlisPara: "TL",
          AlisKur: null,
          SatisFiyat: 0.0,
          SatisPara: "TL",
          SatisKur: null,
          KDV: 0.0,
          Aciklama: "",
        },
        CariList: [],
        EkHizmetler: [],
      },
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      vizeGirisItems: [
        {
          text: this.$t('None'),
          value: -1,
        },
        {
          text: this.$t('Single-entry'),
          value: 0,
        },
        {
          text: this.$t('Multiple-entry'),
          value: 1,
        },
        {
          text: "Transit",
          value: 2,
        },
        {
          text: this.$t('Two-entry'),
          value: 3,
        },
      ],
      vizeTipiItems: [
        {
          text: this.$t('None'),
          value: 0,
        },
        {
          text: "USA",
          value: 1,
        },
        {
          text: "Schengen",
          value: 2,
        },
        {
          text: this.$t('Individual'),
          value: 3,
        },
        {
          text: this.$t('Special'),
          value: 4,
        },
      ],
      headersCari: [
        {
          text: this.$t('Name'),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t('Process'),
          align: "right",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    updateVizeFiyat() {
    if (this.fiyatParams.VizeFiyat.FiyatTipi.kod == null || this.fiyatParams.VizeFiyat.FiyatTipi.kod.length == 0){
          this.text1 = this.$t('The-Visa-Price-Type-field-cannot-be-empty.')
          this.snackbar = true;
          return false;
    }

      this.loadingvmodel = true;
      this.fiyatParams.EkHizmetler = [];
      this.checkEkHizmetler();
      tool.http_post(this, "VizeFiyatUpdate", this.fiyatParams).then(
        (response) => {
          if (response.body.Status == true) {
            this.text1 = this.$t('Record-Updated');
            this.snackbar = true;
            this.loadingvmodel = false;
            var url = "#/coper/tanitimlar/vizefiyat/index";
            window.open(url, "_self");
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
    getVizeFiyat() {
      this.loadingvmodel = true;
      let params = {
        Id: this.$route.query.Ref,
      };
      tool.http_post(this, "VizeFiyatLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.fiyatParams = response.body.data;
            this.fiyatParams.VizeFiyat.Ref = response.body.data.VizeFiyat.Ref;
            for (
              let index = 0;
              index < response.body.data.EkHizmetler.length;
              index++
            ) {
              const element = response.body.data.EkHizmetler[index];
              switch (element.HizmetTip) {
                case 1:
                  this.sigorta = element;
                  break;
                case 2:
                  this.hizmet = element;
                  break;
                case 3:
                  this.diger = element;
                  break;
                case 4:
                  this.ekhizmet1 = element;
                  break;
                case 5:
                  this.ekhizmet2 = element;
                  break;
                case 6:
                  this.ekhizmet3 = element;
                  break;
                case 7:
                  this.ekhizmet4 = element;
                  break;
                case 8:
                  this.ekhizmet5 = element;
                  break;
                case 9:
                  this.ekhizmet6 = element;
                  break;
                case 10:
                  this.ekhizmet7 = element;
                  break;
                default:
                  break;
              }
            }
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
    addVizeFiyat() {


        if (this.fiyatParams.VizeFiyat.FiyatTipi.kod == null || this.fiyatParams.VizeFiyat.FiyatTipi.kod.length == 0){
          this.text1 = this.$t('The-Visa-Price-Type-field-cannot-be-empty.');
          this.snackbar = true;
          return false;
        }


      this.loadingvmodel = true;
      this.checkEkHizmetler();
      tool.http_post(this, "VizeFiyatInsert", this.fiyatParams).then(
        (response) => {
          if (response.body.Status == true) {
            this.text1 = this.$t('Success');
            this.snackbar = true;
            this.loadingvmodel = false;
            var url = "#/coper/tanitimlar/vizefiyat/index";
            window.open(url, "_self");
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
    checkEkHizmetler() {
      if (this.sigorta.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.sigorta);
      }
      if (this.hizmet.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.hizmet);
      }
      if (this.diger.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.diger);
      }
      if (this.ekhizmet1.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.ekhizmet1);
      }
      if (this.ekhizmet2.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.ekhizmet2);
      }
      if (this.ekhizmet3.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.ekhizmet3);
      }
      if (this.ekhizmet4.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.ekhizmet4);
      }
      if (this.ekhizmet5.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.ekhizmet5);
      }
      if (this.ekhizmet6.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.ekhizmet6);
      }
      if (this.ekhizmet7.Satici != null) {
        this.fiyatParams.EkHizmetler.push(this.ekhizmet7);
      }
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    deleteCari(item) {
      const index = this.fiyatParams.CariList.indexOf(item);
      this.fiyatParams.CariList.splice(index, 1);
    },
    addCari() {
      if (this.cariValue != null) {
        this.fiyatParams.CariList.push({
          id: "",
          kod: this.cariValue,
          isim: "",
          tip: 0,
          intField: null,
        });
        this.cariValue = "";
      }
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    konsoloslukminiara,
    tarihim,
    geneltipara,
    parainput,
    cariaracomp,
    ekhizmetler,
    vizecesidi,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    var params1 = {
      CompanyCode: credentials.SirketKodu,
    };

    this.$http
      .post(auth.API_URL + "api/currency/List", params1, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          this.doviztipi = response.body;
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-Döviz";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable-Döviz";
            this.snackbar = true;
          }
        }
      );

    if (this.sayfayetki.Status == true) {
      if (this.$route.query.isl == "get") {
        this.getVizeFiyat();
      }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },
};
</script>

<style>
</style>

